import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Was ist Prana Kundalini-Therapie® und wie unterscheidet sie sich von anderen energetischen Methoden?",
      answer: "Prana Kundalini-Therapie® ist eine ganzheitliche spirituelle und energetische Praxis, die Pranayama (Atemtechniken), Kundalini-Energie und therapeutische Ansätze miteinander verbindet. Sie gilt als eine der effektivsten spirituellen Praktiken und ermöglicht tiefe Transformation auf körperlicher, emotionaler und spiritueller Ebene."
    },
    {
      question: "Wie lange dauert die Ausbildung und wie ist sie strukturiert?",
      answer: "Die Ausbildung umfasst 5 Module, die über 2 Semester pro Jahr verteilt sind. Jedes Modul baut aufeinander auf und vermittelt sowohl theoretisches Wissen als auch praktische Fertigkeiten. Nach erfolgreichem Abschluss erhalten Sie ein Zertifikat in der Berufsgruppe Humanenergetiker."
    },
    {
      question: "Welche Voraussetzungen benötige ich für die Teilnahme?",
      answer: "Es sind keine besonderen Vorkenntnisse erforderlich. Wichtig ist Ihre Offenheit für spirituelle Entwicklung und energetische Arbeit. Die Ausbildung ist sowohl für Anfänger als auch für Menschen mit bereits vorhandener Erfahrung in energetischen Methoden geeignet."
    },
    {
      question: "Kann ich nach der Ausbildung professionell als Energetiker arbeiten?",
      answer: "Ja, nach erfolgreichem Abschluss der 5 Module erhalten Sie ein Zertifikat, das Sie berechtigt, als Humanenergetiker in der Berufsgruppe zu arbeiten. Sie können dann Prana Kundalini-Therapie® professionell anbieten und Klienten behandeln."
    },
    {
      question: "Wie läuft eine typische Behandlung mit Prana Kundalini-Therapie® ab?",
      answer: "Eine Behandlung beginnt mit einem ausführlichen Gespräch, gefolgt von energetischen Techniken wie Atemarbeit, Energieübertragung und speziellen Prana Kundalini-Methoden. Die Behandlung ist ganzheitlich und zielt darauf ab, Blockaden zu lösen und das Energiesystem zu harmonisieren."
    },
    {
      question: "Gibt es Unterstützung während der Ausbildung?",
      answer: "Ja, Sie erhalten kontinuierliche Betreuung durch erfahrene Ausbilder, haben Zugang zu Übungsgruppen und können bei Fragen jederzeit Unterstützung erhalten. Die Gemeinschaft der Teilnehmer bietet zusätzlich wertvollen Austausch und gegenseitige Unterstützung."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary-deep mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-primary-main max-w-3xl mx-auto">
            Antworten auf die wichtigsten Fragen zur Prana Kundalini-Therapie® Ausbildung
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-primary-light/30 rounded-lg px-6 py-2 bg-primary-lightest/30 hover:bg-primary-lightest/50 transition-colors"
              >
                <AccordionTrigger className="text-left text-primary-deep font-semibold hover:text-primary-main">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-primary-deep leading-relaxed pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;